import Component from '@glimmer/component';
import { useStyles } from '@frontile/theme';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

class FormFieldHint extends Component {
  get classes() {
    const {
      formDescription
    } = useStyles();
    return formDescription({
      size: this.args.size,
      class: this.args.class
    });
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <div id={{@id}} class={{this.classes}} data-test-id=\"form-field-hint\" ...attributes>\n      {{yield}}\n    </div>\n  ", {
      strictMode: true
    }), this);
  }
}

export { FormFieldHint as default };
//# sourceMappingURL=hint.js.map
